// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2msPm","messages":"Chat_messages__1itlD","dateDivider":"Chat_dateDivider__mycMX"};